import { useUser } from "@clerk/react";
import { useIsAdmin } from "@/hooks/use-is-admin";
import { Clock } from "lucide-react";

function timeAgo(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function LastSignInBanner() {
  const { user } = useUser();
  const isAdmin = useIsAdmin();
  const lastSignIn = user?.lastSignInAt;

  // Admins don't need the banner - they manage accounts, not monitor their own
  if (isAdmin || !lastSignIn) return null;

  return (
    <div className="bg-slate-100 border-b border-slate-200 text-slate-500 text-xs px-4 py-1.5 flex items-center gap-2">
      <Clock className="h-3 w-3 shrink-0" />
      <span>
        Last sign-in: {timeAgo(new Date(lastSignIn))}
      </span>
    </div>
  );
}
